<template>
  <!-- 产品中心 -->
  <div class="ProductCenter" v-loading="loading">
    <div class="cpzx_bj">
      <img src="@/assets/img/spzx_xqy/banner-bg.png" alt="" />
      <ul class="cpzx_bj_text">
        <li>产品中心</li>
        <li>绿色生态产业链全方位数据专家</li>
        <li></li>
      </ul>
    </div>
    <div class="breadcrumb">
      <div class="breadcrumbBox">
        <img src="@/assets/img/spzx/cpzx_home.png" alt="" />
        <div class="breadcrumbBox_text">
          <span>首页&nbsp;></span>
          <span>产品中心</span>
          <span v-if="currentCategoryName">&nbsp;>&nbsp;{{ currentCategoryName }}</span>
        </div>
      </div>
    </div>
    <div class="ProductCenter_content" id="main-content">
      <div class="contentBox">
        <!-- 分类切换已移至顶部菜单 -->
        <div class="exhibitionBox">
          <div v-show="productArr.length === 0" style="margin: 0 auto;">暂无数据</div>
          <div
            class="item"
            v-for="(item, index) in productArr"
            :key="index"
            @click="itemClick(item)"
          >
            <div class="itemImg">
              <img :src="item.imgUrlList[0]" alt="" />
            </div>
            <div class="itemLine"></div>
            <ul class="itemBottom">
              <li>{{ item.productName }}</li>
              <li>{{ item.brief }}</li>
              <li></li>
              <li>→</li>
            </ul>
          </div>
        </div>
        <div class="pagination">
          <el-pagination
            class="page"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :current-page="page"
            :page-size="pageSize"
            :page-sizes="[8, 12, 24, 48]"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Product from '@/api/product.js'
import {getCategories} from '@/utils/categoryStore.js'

export default {
  name: 'ProductCenter',
  data () {
    return {
      page: 1,
      pageSize: 8,
      total: 0,
      productArr: [],
      loading: false,
      productTypeId: '', // 当前分类ID
      classifyList: [], // 分类列表（用于名称映射和默认值）
      currentCategoryName: '' // 当前分类名称（面包屑）
    }
  },
  methods: {
    // 获取分类列表（仅用于名称映射和默认分类）
    async getClassifyList () {
      try {
        this.classifyList = await getCategories()
      } catch (error) {
        console.error('获取分类列表失败', error)
      }
    },

    // 根据分类ID获取名称
    getCategoryNameById (id) {
      if (!id) return ''
      const found = this.classifyList.find(item => item.id.toString() === id.toString())
      return found ? found.name : ''
    },

    // 加载数据（根据路由参数，若无则使用第一个分类）
    async loadDataFromRoute () {
      await this.getClassifyList()
      let categoryId = this.$route.query.categoryId
      // 如果无参数且分类列表不为空，则默认使用第一个分类
      if (!categoryId && this.classifyList.length > 0) {
        categoryId = this.classifyList[0].id
      }
      this.productTypeId = categoryId ? categoryId.toString() : ''
      this.currentCategoryName = this.getCategoryNameById(this.productTypeId)
      this.page = 1
      this.getProductList()
    },

    // 获取产品列表
    async getProductList () {
      this.loading = true
      const params = {
        productName: '',
        productTypeId: this.productTypeId || '',
        page: this.page,
        pageSize: this.pageSize,
        startTime: '',
        endTime: ''
      }
      try {
        const { code, msg, data, total } = await Product.queryList(params)
        if (code === 200) {
          this.productArr = (data || [])
            .filter(product => product.enable === 1)
            .map(product => {
              if (product.imageUrl) {
                try {
                  const imageUrlArray = JSON.parse(product.imageUrl)
                  product.imgUrlList = Array.isArray(imageUrlArray) ? imageUrlArray : [product.imageUrl]
                } catch (error) {
                  product.imgUrlList = [product.imageUrl]
                }
              } else {
                product.imgUrlList = []
              }
              return product
            })
          this.total = total
        } else {
          this.$message.error(msg)
        }
      } catch (error) {
        this.$message.error('获取产品列表失败')
      } finally {
        this.loading = false
      }
    },

    // 点击产品跳转详情
    itemClick (item) {
      if (item && item.id) {
        this.$router.push({
          name: 'ProductDetails',
          query: {
            projectId: item.id.toString(),
            fromCategoryId: this.productTypeId || '',
            fromCategoryName: ''
          }
        })
      } else {
        this.$message.error('产品数据异常，无法查看详情')
      }
    },

    // 分页事件
    handleCurrentChange (page) {
      this.page = page
      this.getProductList()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.page = 1
      this.getProductList()
    }
  },
  mounted () {
    this.loadDataFromRoute()
    this.$nextTick(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    })
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'ProductCenter') {
        this.loadDataFromRoute()
        this.$nextTick(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.ProductCenter {
  width: 100%;
  .cpzx_bj {
    width: 100%;
    height: 274px;
    position: relative;
    img {
      width: 100%;
      height: 274px;
    }
    .cpzx_bj_text {
      width: 310px;
      height: 134px;
      position: absolute;
      top: 100px;
      left: 50%;
      margin-left: -155px;
      li {
        color: #fff;
        &:nth-child(1) {
          width: 100%;
          height: 56px;
          font-size: 30px;
          padding-left: 68px;
        }
        &:nth-child(2) {
          width: 100%;
          height: 24px;
          font-size: 18px;
        }
        &:nth-child(3) {
          width: 220px;
          height: 4px;
          background-color: #fff;
          margin-top: 22px;
          margin-left: 16px;
          position: relative;
          &:after {
            content: "";
            width: 60px;
            height: 10px;
            background-color: #fff;
            position: absolute;
            top: -3px;
            left: 80px;
          }
        }
      }
    }
  }

  .breadcrumb {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;
    .breadcrumbBox {
      width: 1206px;
      height: 48px;
      font-family: Source Han Sans CN;
      display: flex;
      align-items: center;
      position: relative;
      margin-left: 14px;
      img {
        width: 22px;
        height: 20px;
      }
      .breadcrumbBox_text {
        position: absolute;
        top: 17px;
        left: 40px;
        span {
          font-size: 16px;
          &:nth-child(1) {
            color: #666666;
          }
          &:nth-child(2) {
            color: #2b8737;
          }
          &:nth-child(3) {
            color: #2b8737;
          }
        }
      }
    }
  }

  .ProductCenter_content {
    width: 100%;
    background-color: #f5f5f5;
    padding: 20px 0 36px 0;
    display: flex;
    justify-content: center;

    .contentBox {
      width: 1206px;

      .exhibitionBox {
        width: 100%;
        margin-top: 30px;
        display: flex;
        flex-wrap: wrap;

        .item {
          width: 288px;
          height: 320px;
          margin-top: 20px;
          margin-left: 10px;
          background-color: #fff;
          &:hover {
            cursor: pointer;
          }

          .itemImg {
            width: 100%;
            height: 252px;
            display: flex;
            justify-content: center;
            img {
              width: 100%;
              height: 252px;
            }
          }

          .itemLine {
            width: 100%;
            height: 8px;
            background-color: #2b8737;
          }

          .itemBottom {
            width: 100%;
            height: 60px;
            padding: 10px 0 0 20px;
            background-color: #eee;
            position: relative;

            li {
              &:nth-child(1) {
                width: 214px;
                font-size: 16px;
                height: 22px;
                color: #333333;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              &:nth-child(2) {
                width: 214px;
                font-size: 14px;
                height: 22px;
                color: #8f8f8f;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              &:nth-child(3) {
                width: 1px;
                height: 26px;
                background-color: #8a8a8a;
                position: absolute;
                top: 14px;
                left: 240px;
              }
              &:nth-child(4) {
                height: 26px;
                color: #8a8a8a;
                font-size: 26px;
                position: absolute;
                top: 16px;
                left: 252px;
              }
            }
          }
        }
      }
      .pagination {
        width: 100%;
        height: 50px;
        margin-top: 30px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1c7e28 !important;
}
.el-input__inner:focus {
  border-color: #1c7e28 !important;
}
.ProductCenter .page .el-pagination.is-background .el-pager li:not(.disabled):hover {
  background-color: #1c7e28 !important;
}
.ProductCenter .page .el-pagination__jump .el-input__inner:focus {
  border-color: #1c7e28 !important;
}
.ProductCenter .page .el-select .el-input.is-focus .el-input__inner {
  border-color: #1c7e28 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/productCenter/ProductCenter.vue